/*
 * @Author: Emma lou
 * @Date: 2021-11-11 10:44:37
 * @LastEditTime: 2021-11-11 10:17:32
 * @LastEditors: Emma lou
 * @Description: In User Settings Edit
 * @FilePath: \vue-cli\src\router\index.ts
 */
import { createRouter, createWebHashHistory, RouteRecordRaw } from 'vue-router';
import store from '@/store';
import { routers } from './routes';

const routes: Array<RouteRecordRaw> = routers;
const router = createRouter({
  history: createWebHashHistory(),
  routes,
});

const isDev = process.env.NODE_ENV == "development";
const taskRoute = [
  {
    path: '/home',
    name: 'Home',
    component: () => import('@/views/homehadle/Home.vue'),
    meta: {
      isPortal: true,
      title: "home",
      TabbarShow: true //需要显示底部导航
    }
  },
  {
    path: "/report",
    name: "Report",
    component: () => import("@/views/Report/index.vue"),
    meta: {
      isPortal: true,
      title: "report",
      TabbarShow: true //需要显示底部导航
    }
  },
  {
    path: "/task/:type?",
    name: "Task",
    component: () => import("../views/Task/index.vue"),
    meta: {
      isEDC: true,
      title: "task",
      TabbarShow: true //需要显示底部导航
    }
  },
  {
    path: '/about',
    name: 'About',
    component: () => import('../views/abouthandle/About.vue'),
    meta: {
      isNormal: true,
      title: "about",
      TabbarShow: true //需要显示底部导航
    }
  },
  {
    path: '/home/more',
    name: 'recommendFor',
    component: () => import('../views/homehadle/recommendFor.vue'),
    meta: {
      isPortal: true,
      title: "more",
      TabbarShow: true //需要显示底部导航
    }
  },
  {
    path: "/reportList/:parentId/:label?",
    name: "reportList",
    meta: {
      isPortal: true,
      title: "reports",
      goBack: "Report",
      TabbarShow: false,
    },
    component: () => import("../views/Report/reportGroup.vue")
  },
  {
    path: "/reportView/:reportId/:parendId?",
    name: "reportView",
    meta: {
      isPortal: true,
      title: "reportDetails",
      goBack: "Report",
      TabbarShow: false
    },
    component: () => import("../views/Report/reportView.vue")
  },
  {
    path: "/search/:type?",
    name: "searchsView",
    component: () => import("../components/searchsView.vue"),
    meta: {
      isNormal: true,
      title: "search",
      TabbarShow: false
    }
  },
  {
    path: "/checkData/:reportId/:sheetId/:taskName/:type",
    name: "checkData",
    component: () => import("../views/Task/checkData.vue"),
    meta: {
      isEDC: true,
      title: "checkData",
    }
  },
  {
    path: "/doneCheckData/:reportId/:sheetId/:taskName/:type",
    name: "doneCheckData",
    component: () => import("../views/Task/checkData.vue"),
    meta: {
      isEDC: true,
      title: "doneCheck",
    }
  },
  {
    path: "/checkData/:reportId/:sheetId/:taskName/:type",
    name: "checkData",
    component: () => import("../views/Task/checkData.vue"),
    meta: {
      isEDC: true,
      title: "EDC",
    }
  },
  {
    path: "/sheetSelect/:taskId/:jobID/:taskName?/:type?",
    name: "sheetSelect",
    component: () => import("../views/Task/sheetSelect.vue"),
    meta: {
      isEDC: true,
      title: "EDC",
    }
  },
  {
    path: "/checkForm/:taskId/:jobID/:taskName?/:type?",
    name: "checkForm",
    component: () => import("../views/Task/checkForm.vue"),
    meta: {
      isEDC: true,
      title: "EDC",
    }
  },
  {
    path: "/checkProcess",
    name: "checkProcess",
    component: () => import("../views/Task/checkProcess.vue"),
    meta: {
      isEDC: true,
      title: "EDC",
    }
  },
  {
    path: "/tabs/:tabar/collection", //首页下的收藏
    name: "collection",
    component: () => import("../views/homehadle/collection.vue"),
    meta: {
      isPortal: true,
      title: "collection",
      TabbarShow: true //需要显示底部导航
    }
  },
  {
    path: "/tabs/:tabar/:types?", //最近浏览
    name: "tabsView",
    component: () => import("../views/abouthandle/tabsView.vue"),
    meta: {
      isPortal: true,
      TabbarShow: true
    }
  },
  {
    path: "/tabs/:tabar/message", //我的消息
    name: "myMessage",
    component: () => import("../views/abouthandle/myMessage.vue"),
    meta: {
      title: "message",
      isNormal: true,
      TabbarShow: true
    }
  },
  {
    path: "/collection/:label",
    name: "reportCollent",
    meta: {
      isPortal: true,
      title: "reportCollent",
      goBack: "reportCollent",
      TabbarShow: false,
    },
    component: () => import("../views/homehadle/collection.vue")
  },
  {
    path: "/homeEditor", //首页下的编辑
    name: "homeEditor",
    component: () => import("../views/homehadle/homeEditor.vue"),
    meta: {
      isPortal: true,
      title: "homeEditor",
    }
  },
  {
    path: "/myMessage/:msgid?",
    name: "myMessageDeatil",
    component: () => import("../views/abouthandle/myMessageDeatil.vue"),
    meta: {
      isPortal: true,
      title: "myMessage",
      TabbarShow: false
    }
  },
  {
    path: "/personInfo", //我的个人信息
    name: "personInfo",
    component: () => import("../views/abouthandle/personInfo.vue"),
    meta: {
      title: "profile",
      isNormal: true,
      TabbarShow: false
    },
  },
  {
    path: "/editInfo/:type", //编辑个人信息
    name: "editPersonInfo",
    component: () => import("../views/abouthandle/editPersonInfo.vue"),
    meta: {
      title: "setting",
      isNormal: true,
      TabbarShow: false
    },
  },
  {
    path: "/404",
    name: "404",
    component: () => import("../views/404page.vue"),
    meta: {
      isNormal: true,
    }
  },
]

const getOrigin = (hash?) => {
  const { protocol, hostname, pathname, port } = window.location;
  const currentPort = port ? ":" + port : "";
  return (
    protocol + "//" + hostname + currentPort + pathname + (hash ? hash : "")
  );
}
const GetQueryString = (name) => {
  const reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
  const search = window.location.hash.substr(window.location.hash.indexOf("?"));
  const r = search && search.substr(1).match(reg);
  if (r != null) return decodeURIComponent(r[2]);
  return null;
}
router.beforeEach(async (to, from, next) => {
  const routerName = to.name;
  const { asyncRoutes } = store.state;
  let isAuth = store.state.isAuth;
  let systemConfig = store.state.systemConfig;
  let user = store.state.user;
  const { isQYWeixin, isWeixin, isDingTalk } = store.getters;

  if (!systemConfig || Object.keys(systemConfig).length == 0) {
    await store.dispatch('GetSystemConfig');
    systemConfig = store.state.systemConfig;
  }
  const { isSystemMaintain } = systemConfig

  /**asyn router loading */
  if (isSystemMaintain) {
    to.name !== 'maintenance' ? next({ name: 'maintenance' }) : next()
  } else if (!isSystemMaintain && to.name == 'maintenance') {
    next({ name: 'Login' });
  } else {
    if (to.query.id_token) {
      /**sso login query */
      /**如果携带token进行单点跳转，就先进行token验证 */
      store.commit('setToken', to.query.id_token || GetQueryString('id_token'));
      localStorage.setItem("returnUrl", to.path);
      await store.dispatch('checkToken');
      if (to.query.defaultUrl) {
        const defaultUrl = decodeURIComponent(to.query.defaultUrl as any);

        let hrefUrl = getOrigin() + "#/" + defaultUrl;

        if (defaultUrl.startsWith("http")) {
          hrefUrl = defaultUrl;
        }
        if (defaultUrl.startsWith("/")) {
          hrefUrl = getOrigin() + "#" + defaultUrl;
        }
        location.href = hrefUrl;
      } else {
        next({ name: 'Login' });
      }

    } else if (!asyncRoutes && await store.dispatch('checkToken')) {
      if (!user) {
        await store.dispatch('getCurrentUser');
        user = store.state.user;
      }

      const routeobj = await store.dispatch('getUserConfigGoto');
      let nextObj: any = { ...to };
      const authRoutesList = []
      let isNextToObj = false;
      const { userType } = store.state.user;
      /**获取当前用户的权限，按权限添加路由 */
      const isPortal = userType.some(item => item == 1 || item == 4);
      const isEDC = userType.some(item => item == 2);
      let addFirst = 0;
      for (let index = 0; index < taskRoute.length; index++) {
        const item = taskRoute[index];
        if ((item.meta.isPortal && isPortal) || (item.meta.isEDC && isEDC) || item.meta.isNormal) {
          addFirst++
          if (addFirst == 1) {
            const layout = router.getRoutes().find(a => a.name == 'Layout');
            router.addRoute({ ...layout, redirect: { name: item.name } });
          }
          router.addRoute('Layout', { ...item });
          router.options.routes.push({ ...item });
          authRoutesList.push(item)
          if (item.name == routeobj.name) {
            isNextToObj = true;
          }
        }
      }
      // console.log(router.getRoutes(), "before");
      store.commit('setAsyncRoutes', authRoutesList);
      //已经添加redirect路由，暂时注释此段代码
      // if (to.name == 'Layout' || to.name == 'Login') {
      //   /**if gone to layout redirect the first route */
      //   nextObj = { name: authRoutesList[0].name }

      // }

      if (isNextToObj && (to.fullPath.includes('login') || from.fullPath.includes('login'))) {
        nextObj = { ...routeobj }
      }

      next({ ...nextObj, replace: true });

    } else if (!store.getters.token && (isQYWeixin || isWeixin || isDingTalk) && !isDev) {
      // 企业微信微信和钉钉自动登录
      localStorage.setItem("returnUrl", to.path);
      if (isDingTalk) {
        location.href = "/dingtalkapi/DingTalk/M";
      } else {
        location.href = "/wechatapi/Login/WeChatLoginCallBack";
      }
    } else if (to.name == 'Login') {

      /**if has token is ok, the jump login page */

      /**
       * 
       * TODO: 是否需要修改密码，从CheckLicense接口获取passwordStatus, 弹出需要修改密码的提示框，
       * 并在多少秒后跳转到admin端的密码修改页面
       * 
       */
      if (await store.dispatch('checkToken')) {

        next({ name: 'Layout', query: { ...to.query }, params: { ...to.params } });
      } else {
        next()
      }

    } else {
      if (await store.dispatch('checkToken')) {
        if (!isAuth) {
          isAuth = await store.dispatch('getCheckLicense');
        }

        if (!user) {
          await store.dispatch('getCurrentUser');
          user = store.state.user;
        }

        if (isAuth) {
          const returnUrl = localStorage.returnUrl;
          const result = store.state.asyncRoutes.find(
            item => { return item.name == routerName }
          )
          if (result) {
            next()
          } else {
            next({ name: '404' })
          }
          localStorage.removeItem('returnUrl');
          returnUrl && returnUrl != to.path && !returnUrl.includes('login') ? next({ path: returnUrl }) : next();
        } else {
          await store.commit('Logout');
          next({ name: 'Login' });
        }
      } else {
        next({ name: 'Login' });
      }
      /**if not has license, post get license */

    }
  }
});

export default router;



/**
 * 登录分为：
 * 1.没有token的验证，跳转到login
 * 2.有token且token有效跳转到 系统维护，用户自定义，redirect，或者首页
 * 3.sso登录的验证
 * 4.需要修改密码的提示
 */